import { useEffect } from 'react';
import { useDrop, useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import OptionsTableRow from 'ui-forms-components/options/OptionsTableRow';
import { jsx as _jsx } from "react/jsx-runtime";
const SORTABLE_TYPE = 'SORTABLE_OPTION';
const OptionsTableDraggableRow = props => {
  const {
    value
  } = props;
  const [{
    isDragging
  }, drag, dragPreview] = useDrag(() => ({
    type: SORTABLE_TYPE,
    item: () => {
      props.onDrag();
      return {
        value
      };
    },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      const isValid = item && dropResult;
      return isValid ? item : null;
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  }), [value, props]);
  const [, drop] = useDrop(() => ({
    accept: SORTABLE_TYPE,
    hover(item) {
      if (item.value !== props.value) {
        props.onReorder(item.value, props.value);
      }
    },
    drop: () => {
      props.onDrop();
    },
    collect: monitor => {
      return {
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop()
      };
    }
  }), [props]);
  useEffect(() => {
    dragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }, [dragPreview]);
  return /*#__PURE__*/_jsx("tr", {
    "data-test-id": "options-table-row",
    ref: node => {
      drag(drop(node));
    },
    children: /*#__PURE__*/_jsx(OptionsTableRow, Object.assign({
      isDragging: isDragging
    }, props))
  });
};
export default OptionsTableDraggableRow;